import { createContext, useState, useContext } from "react";

const EcrfContext = createContext(0);
EcrfContext.displayName = "EcrfContext";

export const EcrfProvider = (props) => {
  const [selectedVisit, setSelectedVisit] = useState({
    survey_form: "",
    extra_photos: [],
    app_videos: [],
    visit_schedule: 0,
    visit_number: 0,
    consent_form: {
      content: "",
      title: "",
      id: "",
    },
    consent_list_id: "",
    trial_block: [],
    is_all_instruction: false,
    end_visit_schedule: 0,
    visit_name: "",
  });

  const [zeroVisit, setZeroVisit] = useState(null);
  const [eventList, setEventList] = useState([]);
  const [initialFlag, setInitialFlag] = useState(true);
  const [allVisits, setAllVisits] = useState([]);
  const [hasChanged, setHasChanged] = useState(false);
  const [trialTypes, setTrialTypes] = useState([]);
  const [photoTypes, setPhotoTypes] = useState([]);
  const [localBlocks, setLocalBlocks] = useState([]);
  const [surveyData, setSurveyData] = useState(null);
  const [hasEcrfBlocksChanged, setHasEcrfBlocksChanged] = useState(null);
  const [isAllEcrfBlocks, setIsAllEcrfBlocks] = useState(false);

  const [trial, setTrial] = useState({});
  const [selectedSessionId, setSelectedSessionId] = useState(0);
  const [patientId, setPatientId] = useState();

  return (
    <EcrfContext.Provider
      value={{
        selectedVisit,
        setSelectedVisit,
        zeroVisit,
        setZeroVisit,
        eventList,
        setEventList,
        initialFlag,
        setInitialFlag,
        trial,
        setTrial,
        selectedSessionId,
        setSelectedSessionId,
        patientId,
        setPatientId,
        allVisits,
        setAllVisits,
        hasChanged,
        setHasChanged,
        trialTypes,
        setTrialTypes,
        photoTypes,
        setPhotoTypes,
        localBlocks,
        setLocalBlocks,
        surveyData,
        setSurveyData,
        hasEcrfBlocksChanged,
        setHasEcrfBlocksChanged,
        isAllEcrfBlocks,
        setIsAllEcrfBlocks,
      }}
    >
      {props.children}
    </EcrfContext.Provider>
  );
};

export const useEcrfContext = () => useContext(EcrfContext);
